import { render, staticRenderFns } from "./liberacaoPagamento.vue?vue&type=template&id=9177f656&scoped=true&"
import script from "./liberacaoPagamento.vue?vue&type=script&lang=js&"
export * from "./liberacaoPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9177f656",
  null
  
)

export default component.exports